import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { GAME_CATEGORY_FILTER } from 'core/constants';
import { FormattedTag, RouteLink } from 'core/components';
import { IconFavorite } from 'components/icons/icons-games-filters/icon-favorite';
import { IconSearch } from 'components/icons/icons-games-filters/icon-search';
import { CATEGORIES_ITEMS } from './games-categories-icons';

export const GamesFiltersMenu = ({
  filterCategory,
  toggleSearchInput,
  isOpenSearch,
  className,
  isUserLoggedIn,
}) => {
  const isFavoriteFilterActive = filterCategory === GAME_CATEGORY_FILTER.FAVORITE;
  const NAV_BAR_TEXT_CLASSNAME_DESKTOP = 'text-capitalize font-weight-semi-bold';

  return (
    <>
      {/* MOBILE  */}
      <div className={classNames('games-filters-menu-mobile-container pb-0_25', className)}>
        <div className="games-filters-menu-mobile d-md-none pt-0_25 border-bottom border-top border-white-10 pl-0_25 d-flex">
          {isUserLoggedIn && (
            <RouteLink
              to={`/games/${GAME_CATEGORY_FILTER.FAVORITE.toLowerCase()}`}
              className={classNames(
                'category-item text-center text-decoration-none position-relative px-1_5 px-sm-4 d-flex flex-column align-items-center flex-grow-1',
                { active: isFavoriteFilterActive }
              )}
            >
              <IconFavorite
                className={classNames('icon-favorite-desktop', {
                  active: isFavoriteFilterActive,
                })}
              />

              <FormattedTag
                id="games.category.favorite"
                className={classNames('d-block text-white-70 text-capitalize font-weight-semi-bold category-name line-height-1 text-nowrap', NAV_BAR_TEXT_CLASSNAME_DESKTOP, {
                  'text-white-70': !isFavoriteFilterActive,
                  'text-white': isFavoriteFilterActive,
                })}
              />
            </RouteLink>
          )}

          {CATEGORIES_ITEMS.map(({
            Icon, key, category, to, shouldLoggedIn,
          }) => {
            const isActive = category === filterCategory;

            if (shouldLoggedIn && !isUserLoggedIn) {
              return null;
            }

            return (
              <RouteLink
                key={key}
                to={`/games/${to}`}
                className={classNames('category-item text-center text-decoration-none position-relative px-1_5 px-sm-4 d-flex flex-column align-items-center flex-grow-1', { active: isActive })}
              >
                <Icon className="flex-shrink-0" />
                <FormattedTag
                  className={classNames('d-block text-white-70 text-capitalize font-weight-semi-bold category-name line-height-1 text-nowrap', { active: isActive })}
                  id={key}
                />
              </RouteLink>
            );
          })}
        </div>
      </div>

      {/* DESKTOP  */}
      <div className="games-filters-menu-desktop d-none d-md-flex justify-content-around align-items-center border-bottom border-top border-white-10">
        <div
          role="button"
          tabIndex="0"
          onClick={toggleSearchInput}
          onKeyPress={toggleSearchInput}
          className={classNames('category-item text-center position-relative h-100 pt-1_75 cursor-pointer', { active: isOpenSearch })}
        >
          <IconSearch />
          <FormattedTag
            id="search"
            className={classNames('category-name text-capitalize d-block font-weight-semi-bold pt-1',
              { 'text-white': isOpenSearch },
              { 'text-white-70': !isOpenSearch })}
          />
        </div>

        {isUserLoggedIn && (
          <RouteLink
            to={`/games/${GAME_CATEGORY_FILTER.FAVORITE.toLowerCase()}`}
            className={classNames(
              'category-item text-center position-relative h-100 pt-1_5 text-decoration-none',
              { active: isFavoriteFilterActive }
            )}
          >
            <IconFavorite
              className={classNames('icon-favorite-desktop', {
                active: isFavoriteFilterActive,
              })}
            />

            <FormattedTag
              id="games.category.favorite"
              className={classNames('category-name d-block pt-0_25', NAV_BAR_TEXT_CLASSNAME_DESKTOP, {
                'text-white': isFavoriteFilterActive,
                'text-white-70': !isFavoriteFilterActive,
              })}
            />
          </RouteLink>
        )}

        {CATEGORIES_ITEMS.map(({
          Icon,
          key,
          to,
          category,
          classname,
          shouldLoggedIn,
        }) => {
          const isActive = category === filterCategory;

          if (shouldLoggedIn && !isUserLoggedIn) {
            return null;
          }

          return (
            <RouteLink
              key={key}
              to={`/games/${to}`}
              className={classNames(
                'category-item text-center position-relative h-100 pt-1_5 text-decoration-none',
                { active: isActive },
                classname,
              )}
            >
              <Icon className={classNames('flex-shrink-0', { active: isActive })} />

              <FormattedTag
                id={key}
                className={classNames(
                  'category-name text-capitalize d-block font-weight-semi-bold pt-1_25',
                  { 'text-white': isActive },
                  { 'text-white-70': !isActive },
                )}
              />
            </RouteLink>
          );
        })}
      </div>
    </>
  );
};

GamesFiltersMenu.propTypes = {
  filterCategory: PropTypes.string,
  toggleSearchInput: PropTypes.func.isRequired,
  isOpenSearch: PropTypes.bool,
  className: PropTypes.string,
  isUserLoggedIn: PropTypes.bool.isRequired,
};

GamesFiltersMenu.defaultProps = {
  filterCategory: '',
  isOpenSearch: false,
  className: '',
};

